'use client'
/* eslint-disable import/no-duplicates */
// main.js (or your component file)

import dynamic from 'next/dynamic'
import React from 'react'
import encodedURIQueryStringConverter from '../utils/encodedURIQueryStringConverter'
// import GiftsFooter from './gifts/components/Footer'
// import GiftsHeader from './gifts/components/Layout/Header'
// import GiftsSectionHeading from './gifts/components/SectionHeading'

const COMPONENTS_PATHS = {
  'Default-Theme': {
    Header: dynamic(() => import('./default/components/Layout/Header'), {
      ssr: false,
    }),
    Footer: dynamic(() => import('./default/components/Footer'), {
      ssr: false,
    }),
    ComponentFactory: dynamic(() => import('./default/componentFactory'), {
      ssr: false,
    }),
    SectionHeading: dynamic(
      () => import('./default/components/SectionHeading'),
      { ssr: false }
    ),
  },
  // 'theme-wsi': {
  //   Header: () => dynamic(() => import('./theme-wsi/components/Layout/Header')),
  //   Footer: () => dynamic(() => import('./theme-wsi/components/Footer')),
  //   ComponentFactory: () => dynamic(() => import('./theme-wsi/componentFactory')),
  //   SectionHeading: () => dynamic(() =>
  //     import('./theme-wsi/components/SectionHeading')
  //   ),
  //   Sidebar: () => dynamic(() => import('./theme-wsi/components/Sidebar')),
  // },
  // Fashion: {
  //   Header: () => dynamic(() => import('./fashion/components/Layout/Header')),
  //   Footer: () => dynamic(() => import('./fashion/components/Footer')),
  //   ComponentFactory: () => dynamic(() => import('./fashion/componentFactory')),
  //   SectionHeading: () => dynamic(() =>
  //     import('./fashion/components/SectionHeading')
  //   ),
  // },
  // Elegance: {
  //   Header: () => dynamic(() => import('./elegance/components/Layout/Header')),
  //   Footer: () => dynamic(() => import('./elegance/components/Footer')),
  //   ComponentFactory: () => dynamic(() => import('./elegance/componentFactory')),
  //   SectionHeading: () => dynamic(() =>
  //     import('./elegance/components/SectionHeading')
  //   ),
  // },
  // ScanSure: {
  //   Header: () => dynamic(() => import('./scansure/components/Layout/Header')),
  //   Footer: () => dynamic(() => import('./scansure/components/Footer')),
  //   ComponentFactory: () => dynamic(() => import('./scansure/componentFactory')),
  //   SectionHeading: () => dynamic(() =>
  //     import('./scansure/components/SectionHeading')
  //   ),
  // },
  // Trendsetter: {
  //   Header: () => dynamic(() => import('./trendsetter/components/Layout/Header')),
  //   Footer: () => dynamic(() => import('./trendsetter/components/Footer')),
  //   ComponentFactory: () => dynamic(() => import('./trendsetter/componentFactory')),
  //   SectionHeading: () => dynamic(() =>
  //     import('./trendsetter/components/SectionHeading')
  //   ),
  // },
  // Lifestyle: {
  //   Header: () => dynamic(() => import('./lifestyle/components/Layout/Header')),
  //   Footer: () => dynamic(() => import('./lifestyle/components/Footer')),
  //   ComponentFactory: () => dynamic(() => import('./lifestyle/componentFactory')),
  //   SectionHeading: () => dynamic(() =>
  //     import('./lifestyle/components/SectionHeading')
  //   ),
  // },
  // Beauty: {
  //   Header: () => dynamic(() => import('./beauty/components/Layout/Header')),
  //   Footer: () => dynamic(() => import('./beauty/components/Footer')),
  //   ComponentFactory: () => dynamic(() => import('./beauty/componentFactory')),
  //   SectionHeading: () => dynamic(() => import('./beauty/components/SectionHeading')),
  // },
  // // Moonshot: {
  // //   Header: MoonshotHeader,
  // //   Footer: MoonshotFooter,
  // //   ComponentFactory: MoonshotComponentFactory,
  // //   SectionHeading: MoonshotSectionHeading,
  // // },
  // Moonshot: {
  //   Header: dynamic(() => import('./moonshot/components/Layout/Header')),
  //   // Header: MoonshotHeader,
  //   Footer: dynamic(() => import('./moonshot/components/Footer')),
  //   ComponentFactory: dynamic(() => import('./moonshot/componentFactory')),
  //   SectionHeading: dynamic(() =>
  //     import('./moonshot/components/SectionHeading')
  //   ),
  //   // SectionHeading: MoonshotSectionHeading,
  // },
  // Darknight: {
  //   Header: () => dynamic(() => import('./darknight/components/Layout/Header')),
  //   Footer: () => dynamic(() => import('./darknight/components/Footer')),
  //   ComponentFactory: () => dynamic(() => import('./darknight/componentFactory')),
  //   SectionHeading: () => dynamic(() =>
  //     import('./darknight/components/SectionHeading')
  //   ),
  // },
  // Pharma: {
  //   Header: () => dynamic(() => import('./pharma/components/Layout/Header')),
  //   Footer: () => dynamic(() => import('./pharma/components/Footer')),
  //   ComponentFactory: () => dynamic(() => import('./pharma/componentFactory')),
  //   SectionHeading: () => dynamic(() => import('./pharma/components/SectionHeading')),
  // },
  // MediCore: {
  //   Header: () => dynamic(() => import('./medicore/components/Layout/Header')),
  //   Footer: () => dynamic(() => import('./medicore/components/Footer')),
  //   ComponentFactory: () => dynamic(() => import('./medicore/componentFactory')),
  //   SectionHeading: () => dynamic(() =>
  //     import('./medicore/components/SectionHeading')
  //   ),
  // },
  // HealthNext: {
  //   Header: () => dynamic(() => import('./healthnext/components/Layout/Header')),
  //   Footer: () => dynamic(() => import('./healthnext/components/Footer')),
  //   ComponentFactory: () => dynamic(() => import('./healthnext/componentFactory')),
  //   SectionHeading: () => dynamic(() =>
  //     import('./healthnext/components/SectionHeading')
  //   ),
  // },
  Quick: {
    Header: dynamic(() => import('./quickshop/components/Layout/Header'), {
      ssr: false,
    }),
    Footer: dynamic(() => import('./quickshop/components/Footer'), {
      ssr: false,
    }),
    ComponentFactory: dynamic(() => import('./quickshop/componentFactory'), {
      ssr: false,
    }),
    SectionHeading: dynamic(
      () => import('./quickshop/components/SectionHeading'),
      { ssr: false }
    ),
  },
  // Zopnow: {
  //   Header: () => dynamic(() => import('./zopnow/components/Layout/Header')),
  //   Footer: () => dynamic(() => import('./zopnow/components/Footer')),
  //   ComponentFactory: () => dynamic(() => import('./zopnow/componentFactory')),
  //   SectionHeading: () => dynamic(() => import('./zopnow/components/SectionHeading')),
  //   Sidebar: () => dynamic(() => import('./zopnow/components/Sidebar')),
  //   Cart: () => dynamic(() => import('./zopnow/components/CartPage')),
  // },
  // Sports: {
  //   Header: () => dynamic(() => import('./sports/components/Layout/Header')),
  //   Footer: () => dynamic(() => import('./sports/components/Footer')),
  //   ComponentFactory: () => dynamic(() => import('./sports/componentFactory')),
  //   SectionHeading: () => dynamic(() => import('./sports/components/SectionHeading')),
  // },
  // Getz: {
  //   Header: () => dynamic(() => import('./getz/components/Layout/Header')),
  //   Footer: () => dynamic(() => import('./getz/components/Footer')),
  //   ComponentFactory: () => dynamic(() => import('./getz/componentFactory')),
  //   SectionHeading: () => dynamic(() => import('./getz/components/SectionHeading')),
  // },
  // ZopStore: {
  //   Header: () => dynamic(() => import('./zopstore/components/Layout/Header')),
  //   Footer: () => dynamic(() => import('./zopstore/components/Footer')),
  //   ComponentFactory: () => dynamic(() => import('./zopstore/componentFactory')),
  //   SectionHeading: () => dynamic(() =>
  //     import('./zopstore/components/SectionHeading')
  //   ),
  // },
  // Titan: {
  //   Header: () => dynamic(() => import('./titan/components/Layout/Header')),
  //   Footer: () => dynamic(() => import('./titan/components/Footer')),
  //   ComponentFactory: () => dynamic(() => import('./titan/componentFactory')),
  //   SectionHeading: () => dynamic(() => import('./titan/components/SectionHeading')),
  // },
  // 'Personal-care': {
  //   Header: () => dynamic(() => import('./personal/components/Layout/Header')),
  //   Footer: () => dynamic(() => import('./personal/components/Footer')),
  //   ComponentFactory: () => dynamic(() => import('./personal/componentFactory')),
  //   SectionHeading: () => dynamic(() =>
  //     import('./personal/components/SectionHeading')
  //   ),
  // },
  // Fresh: {
  //   Header: () => dynamic(() => import('./fresh/components/Layout/Header')),
  //   Footer: () => dynamic(() => import('./fresh/components/Layout/Footer')),
  //   ComponentFactory: () => dynamic(() => import('./fresh/componentFactory')),
  //   SectionHeading: () => dynamic(() => import('./fresh/components/SectionHeading')),
  //   Cart: () => dynamic(() => import('./fresh/components/Cart')),
  // },

  // TropiWave: {
  //   Header: () => dynamic(() => import('./tropiwave/components/Layout')),
  //   Footer: () => dynamic(() => import('./tropiwave/components/Footer/index')),
  //   ComponentFactory: () => dynamic(() => import('./tropiwave/componentFactory')),
  //   SectionHeading: () => dynamic(() =>
  //     import('./tropiwave/components/SectionHeading')
  //   ),
  // },
  // Value: {
  //   Header: () => dynamic(() => import('./value/components/Layout')),
  //   Footer: () => dynamic(() => import('./value/components/Footer/index')),
  //   ComponentFactory: () => dynamic(() => import('./value/componentFactory')),
  //   SectionHeading: () => dynamic(() => import('./value/components/SectionHeading')),
  // },
  // Glide: {
  //   Header: () => dynamic(() => import('./glide/components/Header')),
  //   Footer: () => dynamic(() => import('./glide/components/Footer')),
  //   ComponentFactory: () => dynamic(() => import('./glide/componentFactory')),
  //   SectionHeading: () => dynamic(() => import('./glide/components/SectionHeading')),
  // },
  // InkGlow: {
  //   Header: () => dynamic(() => import('./inkglow/components/Header')),
  //   Footer: () => dynamic(() => import('./inkglow/components/Footer')),
  //   ComponentFactory: () => dynamic(() => import('./inkglow/componentFactory')),
  //   SectionHeading: () => dynamic(() =>
  //     import('./inkglow/components/SectionHeading')
  //   ),
  // },
  // Bazar: {
  //   Header: dynamic(() => import('./bazar/components/Layout/Header')),
  //   Footer: dynamic(() => import('./quickshop/components/Footer')),
  //   ComponentFactory: dynamic(() => import('./bazar/componentFactory')),
  //   SectionHeading: dynamic(() =>
  //     import('./quickshop/components/SectionHeading')
  //   ),
  // },
}

function generateGoogleFontURL(params) {
  return encodedURIQueryStringConverter(
    'https://fonts.googleapis.com/css',
    params
  )
}

const FONT_CONFIG = {
  'Default-Theme': {
    family: 'Open+Sans:400,600,800',
    display: 'swap',
  },
  Pharma: {
    family: 'Roboto',
    display: 'swap',
  },
  Elegance: {
    family: 'Roboto',
    display: 'swap',
  },
  Getz: {
    family: 'Lato',
    display: 'swap',
  },
  default: {
    family: 'Open+Sans:400,600,800',
    display: 'swap',
  },
}

function getFontUrl(theme) {
  return generateGoogleFontURL(
    FONT_CONFIG[theme] ? FONT_CONFIG[theme] : FONT_CONFIG.default
  )
}

function Header({ websiteTheme, ...props }) {
  const theme = websiteTheme || 'Default-Theme'
  const ThemeHeader =
    COMPONENTS_PATHS[theme]?.Header || COMPONENTS_PATHS['Default-Theme'].Header
  // const ThemeHeader = ThemeHeaderComponent()
  return <ThemeHeader {...props} />
}

function Footer({ websiteTheme, ...props }) {
  const theme = websiteTheme || 'Default-Theme'
  const ThemeFooter =
    COMPONENTS_PATHS[theme]?.Footer || COMPONENTS_PATHS['Default-Theme'].Footer
  // const ThemeFooter = ThemeFooterComponent()
  return <ThemeFooter {...props} />
}

function Sidebar({ websiteTheme, ...props }) {
  const theme = websiteTheme || 'Default-Theme'
  const ThemeSidebar = COMPONENTS_PATHS[theme]?.Sidebar
  // if (!ThemeSidebarComponent) {
  //   return null
  // }
  // const ThemeSidebar = ThemeSidebarComponent()
  return ThemeSidebar ? <ThemeSidebar {...props} /> : null
}

function FixedCartBottom({ websiteTheme, ...props }) {
  const theme = websiteTheme || 'Default-Theme'
  const ThemeCart = COMPONENTS_PATHS[theme]?.Cart
  // if (!ThemeCartComponent) {
  //   return null;
  // }
  // const ThemeCart = ThemeCartComponent();
  return ThemeCart ? <ThemeCart {...props} /> : null
}

function SectionHeading({ websiteTheme, ...props }) {
  const theme = websiteTheme || 'Default-Theme'
  const ThemeSectionHeading =
    COMPONENTS_PATHS[theme]?.SectionHeading ||
    COMPONENTS_PATHS['Default-Theme'].SectionHeading
  // const ThemeSectionHeading = ThemeSectionHeadingComponent()
  return <ThemeSectionHeading {...props} websiteTheme={websiteTheme} />
}

function LayoutComponent({ websiteTheme, ...props }) {
  const theme = websiteTheme || 'Default-Theme'
  const ThemeComponent =
    COMPONENTS_PATHS[theme]?.ComponentFactory ||
    COMPONENTS_PATHS['Default-Theme'].ComponentFactory
  // const ThemeComponent = ThemeComponentFactory()
  return <ThemeComponent {...props} websiteTheme={websiteTheme} />
}

export {
  FixedCartBottom,
  Footer,
  Header,
  LayoutComponent,
  SectionHeading,
  Sidebar,
  getFontUrl,
}
